import * as React from "react"

import {
	Collapse,
	DataTableCellAlphaNumeric,
	DataTableRow,
} from "@walmart-web/livingdesign-components"
import { ChevronDown, ChevronUp } from "@walmart-web/livingdesign-icons"

import Badge, {
	BadgeProps,
} from "components/Transactional/SelloutReport/Table/Badge"
import ReportsDetailTable from "components/Transactional/SelloutReport/ReportsDetailTable"
import { SelloutReportItem } from "components/Transactional/SelloutReport/service"
import "./index.scss"

interface SelloutTableRowProps {
	index: number
	date: string
	filename: string
	reports: SelloutReportItem[]
	reportTypeProps: BadgeProps
	setMessage: () => void
	setDisableDownload: (disableDownload: boolean) => void
	disableDownload: boolean
	isOpen: number
	setIsOpen: (isOpen: number) => void
}

const arrowValue = (index: number, isOpen: number) => {
	return index === isOpen ? (
		<ChevronUp className="arrow" />
	) : (
		<ChevronDown className="arrow" />
	)
}

const SelloutTableRow: React.FC<SelloutTableRowProps> = ({
	index,
	date,
	reports,
	reportTypeProps,
	setMessage,
	setDisableDownload,
	disableDownload,
	isOpen,
	setIsOpen,
}): JSX.Element => (
	<>
		<DataTableRow
			role="body-table-row"
			onClick={() => setIsOpen(index === isOpen ? -1 : index)}
			UNSAFE_className="accordion-tab"
		>
			<DataTableCellAlphaNumeric UNSAFE_className="bold">
				{arrowValue(index, isOpen)}
				{date}
			</DataTableCellAlphaNumeric>
			<DataTableCellAlphaNumeric>
				<Badge {...reportTypeProps} />
			</DataTableCellAlphaNumeric>
		</DataTableRow>
		<DataTableRow role="body-table-row">
			<DataTableCellAlphaNumeric colSpan={4} UNSAFE_className="row-padding">
				<Collapse isOpen={index === isOpen}>
					<ReportsDetailTable
						setMessage={setMessage}
						reports={reports}
						disableDownload={disableDownload}
						setDisableDownload={setDisableDownload}
					></ReportsDetailTable>
				</Collapse>
			</DataTableCellAlphaNumeric>
		</DataTableRow>
	</>
)

export default SelloutTableRow
